/**
@license
Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/

'use strict';

import * as utils from './utils'

// render enqueuer/flusher
let flushList = [];
let scheduled;
export function enqueue(callback) {
  if (!scheduled) {
    scheduled = true;
    utils.microtask(flush);
  }
  flushList.push(callback);
}

export function flush() {
  scheduled = false;
  let didFlush = Boolean(flushList.length);
  while (flushList.length) {
    flushList.shift()();
  }
  return didFlush;
}

flush.list = flushList;


// WEBPACK FOOTER //
// ./~/cloudydom/src/flush.js